import { Link, withRouter } from 'react-router-dom';
import React from 'react';
import {
	getPropertyScopedNavItems,
	resolvePropertyPath,
} from './propertyScopedNavigation';

/**
 * @param {{
 *  activePath?: string,
 *  className?: string,
 *  history: { push: (path: string) => void },
 *  propertyId?: string,
 *  stretchDesktop?: boolean
 * }} props
 * @returns {JSX.Element | null}
 */
function PropertySubmenu(props) {
	const [isMobileWidth, setIsMobileWidth] = React.useState(false);

	React.useEffect(() => {
		const mediaQuery = window.matchMedia('(max-width: 767px)');
		const handleChange = (event) => {
			setIsMobileWidth(event.matches);
		};

		setIsMobileWidth(mediaQuery.matches);

		if (typeof mediaQuery.addEventListener === 'function') {
			mediaQuery.addEventListener('change', handleChange);

			return () => {
				mediaQuery.removeEventListener('change', handleChange);
			};
		}

		mediaQuery.addListener(handleChange);

		return () => {
			mediaQuery.removeListener(handleChange);
		};
	}, []);

	if (!props.propertyId) {
		return null;
	}
	const propertyId = props.propertyId;
	const navItems = getPropertyScopedNavItems();

	if (!isMobileWidth) {
		const desktopLayoutClass = props.stretchDesktop
			? '2xl:grid 2xl:grid-cols-7 2xl:items-center 2xl:gap-2'
			: '';
		const desktopItemAlignmentClass = props.stretchDesktop
			? '2xl:justify-self-center'
			: '';

		return (
			<nav
				className={`flex w-full flex-wrap items-center gap-x-3 gap-y-1 ${desktopLayoutClass} ${
					props.className ?? ''
				}`.trim()}
			>
				{navItems.map((item) => {
					const resolvedPath = resolvePropertyPath(
						item.path,
						propertyId
					);
					const isActive = props.activePath === resolvedPath;

					return (
						<Link
							className={
								isActive
									? `inline-flex items-center whitespace-nowrap rounded-md bg-theme-light text-black font-semibold px-2 py-2 border-b-2 border-theme no-underline ${desktopItemAlignmentClass}`.trim()
									: `inline-flex items-center whitespace-nowrap rounded-md bg-transparent text-grey-700 hover:bg-grey-100 hover:text-black px-2 py-2 no-underline ${desktopItemAlignmentClass}`.trim()
							}
							key={item.key}
							to={resolvedPath}
						>
							{item.label}
						</Link>
					);
				})}
			</nav>
		);
	}

	return (
		<section className={props.className}>
			<section>
				<label
					className="block mb-1 text-xs font-semibold uppercase tracking-wide text-grey-700"
					htmlFor="property-submenu-selector"
				>
					Sections
				</label>
				<select
					className="input w-full"
					id="property-submenu-selector"
					onChange={(event) => props.history.push(event.target.value)}
					value={props.activePath ?? ''}
				>
					{navItems.map((item) => {
						const resolvedPath = resolvePropertyPath(
							item.path,
							propertyId
						);

						return (
							<option key={item.key} value={resolvedPath}>
								{item.label}
							</option>
						);
					})}
				</select>
			</section>
		</section>
	);
}

export default withRouter(PropertySubmenu);
